import styled from "styled-components";

const StyledSection = styled.section`
  color: grey;
  display: flex;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  justify-content: center;
  letter-spacing: 1px;
  padding-bottom: 16px;
  padding-top: 16px;
  position: relative;
  text-transform: uppercase;
  width: 100%;
  max-width: 1532px;
  margin: 0px auto;
  padding: 0px 84px;
  height: 5vh;
  &:before {
    background-color: rgb(196, 196, 196);
    content: "";
    display: block;
    height: 1px;
    position: absolute;
    top: 0px;
    width: calc(80%);
  }
  small {
    padding: 10px 0;
  }

  @media (max-width: 575.98px) {
    width: 100%;
    small {
      font-size: 80.01%;
      white-space: nowrap;
    }
  }
`;

const Footer = () => {
  return (
    <StyledSection>
      <small>© 2026 Designed & Built by Zayn Shams &nbsp;·&nbsp; No AI was harmed (or used) in the making of this website</small>
    </StyledSection>
  );
};

export default Footer;
